import React, { useMemo, useState } from 'react';
import SimpleMdeReact from 'react-simplemde-editor';
import SaveButton from './SaveButton';
import MarkdownIt from 'markdown-it/index.js';


const CreateExhibit = ({ setOpenSnackBar, setErrorMsg }) => {
    const [title, setTitle] = useState('');
    const [value, setValue] = useState('');
    const [error, setError] = useState('');

    // Initialize markdown-it for custom preview rendering
    const mdParser = useMemo(() => new MarkdownIt(), []);

    // Memoize editor options and provide a custom preview renderer and toolbar
    const editorOptions = useMemo(() => ({
        previewRender(plainText) {
            return `<div class="markdown-body">${mdParser.render(plainText)}</div>`;
        },
        toolbar: [
            'bold', 'italic', 'heading', '|',
            'quote', 'unordered-list', 'ordered-list', '|',
            'link', 'image', '|',
            'preview', '|',
            'guide'
        ],
    }), [mdParser]);

    const handleTitleChange = (e) => {
        const newTitle = e.target.value;

        // Validation: ASCII letters and numbers only, max length of 21 characters including spaces
        const validTitle = newTitle.replace(/[^A-Za-z0-9 ]/g, '').slice(0, 21);

        if (newTitle.length > 21) {
            setError('Title can be at most 21 characters.');
        } else if (newTitle !== validTitle) {
            setError('Title can only contain ASCII letters and numbers.');
        } else {
            setError('');
        }
        setTitle(validTitle); // Only allow valid titles
    };

    const handleContentChange = (value) => {
        setValue(value);
    };

    return (
        <div>
            <div>
                <input className='edit-exhibit-title' type='text' placeholder='Title (max 21 chars)' style={{ width: '100%', padding: '10px', fontSize: '18px' }}
                    value={title}
                    onChange={handleTitleChange}
                />
                {error && <p style={{ color: 'red' }} />}
                <SimpleMdeReact value={value} onChange={handleContentChange} options={editorOptions} />
            </div>
            <div style={{ marginTop: '20px' }}>
                <SaveButton isDraft={false} value={value} title={title} setOpenSnackBar={setOpenSnackBar} setErrorMsg={setErrorMsg} />
            </div>
        </div>
    );
};

export default CreateExhibit;